export default __webpack_public_path__ + "static/media/reminder.1cc465c1.svg";